import { useTheme } from '@mui/styles';
import { muiTheme } from '@tassat/payments-themes';
import React from 'react';

import muiStyles from './styles';
import { BasicButtonProps } from './types';

export default function Button(props: BasicButtonProps) {
    const {
        id,
        className,
        testId,
        type,
        text,
        disabled,
        Icon,
        iconPosition = 'left',
        iconColor,
        onClick
    } = props;
    const classes = muiStyles(props);
    const theme = useTheme<typeof muiTheme>();

    const buttonStyle = React.useMemo(() => {
        const buttonStyleMap = {
            main: {
                background: classes.mainButtonStyle,
                text: classes.mainButtonTextStyle
            },
            mainSmall: {
                background: classes.mainButtonSmallStyle,
                text: classes.mainButtonTextStyle
            },
            mainSlim: {
                background: classes.mainButtonSlimStyle,
                text: classes.mainButtonTextStyle
            },
            cancelSmall: {
                background: classes.cancelButtonSmallStyle,
                text: classes.cancelButtonTextStyle
            },
            whiteSlim: {
                background: classes.whiteSlimStyle,
                text: classes.mainButtonTextStyle
            },
            noBgBlue: {
                background: classes.noBgBlue,
                text: classes.noBgBlueText
            },
            action: {
                background: classes.noBgBlue,
                text: classes.noBgBlueText
            },
            submit: {
                background: classes.submitButtonStyle,
                text: classes.mainButtonTextStyle
            },
            cancel: {
                background: classes.cancelButtonStyle,
                text: classes.cancelButtonTextStyle
            },
            blueSlim: {
                background: classes.blueSlimStyle,
                text: classes.blueTextStyle
            },
            greenSubmit: {
                background: classes.greenSubmit,
                text: classes.greenSubmitTextStyle
            },
            redSubmit: {
                background: classes.redSubmit,
                text: classes.redSubmitTextStyle
            }
        };

        return buttonStyleMap[type] ?? {
            background: classes.cancelButtonStyle,
            text: classes.mainButtonTextStyle
        };
    }, [ classes, type ]);

    const textIcon = () => {
        if (!Icon) return null;

        return (
            <Icon
                className={classes.iconStyling}
                iconColor={iconColor ||
                    theme?.app?.applicationColors.enumColors.white ||
                    '#375073'}
            />
        );
    };

    return (
        <button
            className={`${classes.root} ${buttonStyle.background}
                ${classes.buttonText} ${buttonStyle.text}
                ${className || ''}`}
            data-testid={testId ? testId : ''}
            disabled={disabled}
            id={id || ''}
            onClick={(e) => {
                e.preventDefault();
                onClick(e);
            }}
            type='button'
        >
            <div className={classes.contentStyling}>
                {iconPosition === 'left' && textIcon()}
                {text}
                {iconPosition === 'right' && textIcon()}
            </div>
        </button>
    );
}